var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");

var GlobalXHandleModel = require("./globalXRotationModel.js");
var GlobalXHandleView = require("./globalXRotationView.js");

var Editor3d = require("./../../editor3d/editor3dController.js");

var GlobalXRotationController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
};

lib_core.inherit(GlobalXRotationController, lib_core.Controller);
GlobalXRotationController.inject = {
    editor3d : Editor3d
};

module.exports = GlobalXRotationController;

GlobalXRotationController.prototype.handleId = "rotationGlobalX";

GlobalXRotationController.prototype.createModel = function () {
    var editor3dModel = this.editor3d.getModel();

    return new GlobalXHandleModel(editor3dModel, this.handleId, this.configuration);
};


GlobalXRotationController.prototype.createView = function () {
    var editor3dView = this.editor3d.getView();

    return new GlobalXHandleView(this.getModel(), editor3dView, this.handleId, this.configuration);
};



